export { default } from '@shikijs/langs/tsx'
